import { COOKIE_LOAN_SEARCH } from '@/constants/cookies';
import { PRODUCT_LOANS } from '@/constants/products';
import { getLoans, getLoanSearch } from '@/graphql/queries/banking/loan';
import { getProviders } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/banking/loans';

export default async ({ $api, $apolloQuery, app, $cookies, redirect, store }) => {
  const code = $cookies.get(COOKIE_LOAN_SEARCH);
  const backHome = () => redirect(302, app.localePath('/compare-loans/'));
  if (!code) backHome();
  store.$i18n.mergeLocaleMessage('en', lang.en);
  store.commit('pageContent/setHead', { title: store.$i18n.t('your-results.title') });
  await $api('banking/loansearches').then(r => store.commit('products/setValidations', r));
  await $apolloQuery(getLoanSearch, { code }).then(search => store.commit('search/set', search)).catch(backHome);
  await $apolloQuery(getLoans).then(loans => store.commit('products/setList', loans));
  await $apolloQuery(getProviders, { product: PRODUCT_LOANS }).then(providers => store.commit('providers/setList', providers));
};
